module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9534_saphire_blue.642d1197.jpg";